import React from 'react';
import { Table, Input, Button, Row, Col, Card, FormGroup, Label, CardBody, Spinner, Alert, Tooltip } from 'reactstrap';
import axios from 'axios';
import Http from '../Http';
import { PropTypes } from "prop-types";
import { Redirect, Link } from 'react-router-dom';

class ClientsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      selectedClients: [],
      clients: [],
      clientDetailsId: null,
      alertVisible: false,
      alertText: false,
      tooltipNameOpen: false,
      buttonClasses: "animation-on-hover float-right m-3 disabled",
      type: this.props.type
    }

    this.handleChangeSelectedClients = this.handleChangeSelectedClients.bind(this)
    this.getClients = this.getClients.bind(this)
    this.selectAll = this.selectAll.bind(this)
    this.onShowAlert = this.onShowAlert.bind(this)
    this.api = '/api/v1';
    this.timeouts = []
    //QCLIENT: env aggiungere api link
  }

  async getClients() {
    let { selectedClients } = this.state
    //se è coefficienti e indici il min è 2, se è mappa, selezionando un solo cliente, può anche simulare
    if (selectedClients.length < 2 && this.props.match.path != "/mappa") {
      await this.clearTimeouts()
      this.setState({
        alertVisible: true,
        alertText: "Seleziona almeno 2 competitor",
        alertColor: "danger"
      }, () => {
        let id = window.setTimeout(() => {
          this.setState({ alertVisible: false })
        }, 2000)
        this.timeouts.push(id)
      });
    } else {

      this.setState({
        buttonClasses: "animation-on-hover float-right btn-loading m-3 disabled"
      })

      let data = new FormData()
      let { selectedClients } = this.state
      let res
      data.append('filters', JSON.stringify({
        indexName: 'mappa',
        max_result: 1000,
        clientsId: selectedClients,
        from: this.props.user.reports.newestReportYear - 4,
        to: this.props.user.reports.newestReportYear,
      }))
      try {
        res = await axios.post(`${this.api}/clients-with-filters`, data)
      } catch (error) {
        // alert('Si è verificato un errore.')
        console.log(e)
        this.setState({
          error: 'Si è verificato un errore',
          buttonClasses: "animation-on-hover float-right m-3 disabled",
          loading: false
        });
      }
      this.props.onDataDownloaded(res.data.data)




      // let calls = []
      // this.setState({
      //   buttonClasses: "animation-on-hover float-right btn-loading disabled"
      // })
      // this.state.selectedClients.map((id) => {
      //   calls.push(axios.get(`${this.api}/client/` + id))
      // })
      // axios.all(calls)
      //   .then(responseArr => {
      //     let cleanedData = []
      //     responseArr.map(el => {
      //       cleanedData.push(el.data.data)
      //     })
      //     this.props.onDataDownloaded(cleanedData)
      //   }).catch((e) => {
      //     // alert('Si è verificato un errore.')
      //     console.log(e)
      //     this.setState({
      //       error: 'Si è verificato un errore',
      //       buttonClasses: "animation-on-hover float-right disabled",
      //       loading: false
      //     });
      //   });
    }

  }

  openClientDetails(clientId) {
    this.setState({
      clientDetailsId: clientId
    })
  }

  componentDidMount() {
    let url = this.api + '/clients' + (this.state.type != '' ? '?type=' + this.state.type : '')
    Http.get(url)
      .then((response) => {
        const { data } = response.data;
        this.setState({
          clients: data,
          error: false,
          loading: false
        });
      }).catch((e) => {
        this.setState({
          error: 'Si è verificato un errore',
          buttonClasses: "animation-on-hover float-right m-3 disabled",
          loading: false
        });
      });
  }

  async clearTimeouts() {
    //pulisco i timeouts
    await this.timeouts.map(timeout => {
      window.clearTimeout(timeout);
    })
    this.timeouts = []
  }

  async handleChangeSelectedClients(client) {
    const target = client.id;
    let { selectedClients } = this.state
    let { maxCheckboxes } = this.props

    //rimuovo l'id se c'è già
    if (selectedClients.indexOf((target)) > -1) {
      selectedClients.splice(selectedClients.indexOf((target)), 1)
      this.onShowAlert(selectedClients.length)
    } else {
      if (selectedClients.length < maxCheckboxes || maxCheckboxes == -1) { //aggiungo l'id se è possibile
        selectedClients.push(target)
        this.onShowAlert(selectedClients.length)
      } else {
        await this.clearTimeouts()
        this.setState({
          alertVisible: true,
          alertText: "Non è possibile selezionare più di " + maxCheckboxes + " competitor",
          alertColor: "danger"
        }, () => {
          let id = window.setTimeout(() => {
            this.setState({ alertVisible: false })
          }, 2000)
          this.timeouts.push(id)
        });
      }
    }
    await this.setState({
      selectedClients
    })

    this.updateCheckedClients()
  }

  async handleSelectAllButton() {
    let clients = this.state.clients
    let selectedClients = []
    if (clients.length != this.state.selectedClients.length) {
      clients.map((client) => {
        selectedClients.push(client.id)
      })

    } else {
      this.setState({
        selectedClients: []
      })
    }
    await this.setState({
      selectedClients
    })
    this.updateCheckedClients()
  }

  updateCheckedClients() {
    let { selectedClients, clients } = this.state
    clients.map((client) => {
      client.checked = selectedClients.indexOf(client.id) > -1 ? true : false
    })

    let buttonClasses = "animation-on-hover float-right m-3 disabled"
    if (selectedClients.length > 0) {
      buttonClasses = "animation-on-hover m-3 float-right"
    }

    this.setState({
      clients,
      buttonClasses
    })
  }

  async onShowAlert(length) {
    await this.clearTimeouts()
    if (length > 0) {
      let { selectedClients } = this.state
      this.setState({
        alertVisible: true,
        alertText: "Sono stati selezionati " + selectedClients.length + " competitor",
        alertColor: "dark"
      }, () => {
        let id = window.setTimeout(() => {
          this.setState({ alertVisible: false })
        }, 2000)
        this.timeouts.push(id)
      });
    } else { //rimuovo l'alert se non c'è nessun cliente
      this.setState({ alertVisible: false })
    }
  }

  toggleTooltip = targetName => {
    if (!this.state[targetName]) {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: true
        }
      });
    } else {
      this.setState({
        ...this.state,
        [targetName]: {
          tooltipOpen: !this.state[targetName].tooltipOpen
        }
      });
    }
  };

  isTooltipOpen = targetName => {
    return this.state[targetName] ? this.state[targetName].tooltipOpen : false;
  };

  selectAll() {
    let { clients } = this.state
    clients.map((client) => {
      this.handleChangeSelectedClients(client)
    })
  }

  selectAteco(ateco) {
    let { clients } = this.state
    clients.map((client) => {
      if (client.ateco_2007 == ateco) {
        this.handleChangeSelectedClients(client)
      }
    })
  }

  render() {
    let { loading, selectedClients, clientDetailsId, alertVisible, alertColor, alertText, clients, buttonClasses, type } = this.state
    let { name } = this.props
    if (loading) {
      return (
        <div className="content text-center">
          <Spinner style={{ width: '3rem', height: '3rem' }} type="grow" />
        </div>
      )
    } else {
      if (clientDetailsId > 0) {
        return (
          <Redirect to={'/statistiche-competitor/' + clientDetailsId} />
        )
      } else {
        let nextBtn = ''
        if (this.props.onDataDownloaded) {
          nextBtn = <Button className={buttonClasses} color="primary" onClick={this.getClients}>
            {this.props.btnTitle}
          </Button>
        } else if (type == 'evolution') {
          nextBtn = <Link to={'/evolution/' + selectedClients[0]} ><Button className={buttonClasses} color="primary">
            {this.props.btnTitle}
          </Button></Link>
        } else {
          nextBtn = <Link to={'/statistiche-competitor/' + selectedClients[0]} ><Button className={buttonClasses} color="primary">
            {this.props.btnTitle}
          </Button></Link>

        }
        return (<Row>
          <Col md="12">
            <Alert color={alertColor} className="alert-fixed" isOpen={alertVisible} >
              {alertText}
            </Alert>
            <Card>
              <Row>
                <Col>
                  <h3 className="text-left m-3">{name.toUpperCase().replace(/\|/g, "")}</h3>
                </Col>
                <Col>
                  {nextBtn}
                </Col>
              </Row>
              <CardBody>
                <Table >
                  <thead>
                    <tr>
                      <th>Nome</th>
                      {this.props.user.settoriale == 0 ? (<th>Ateco</th>) : null}
                      <th>Peso %</th>
                      <th>Posizione</th>
                      <th className="text-center">{this.props.maxCheckboxes == -1 ?
                        (<Button className="btn-sm" color="secondary" onClick={this.selectAll}>Seleziona tutti</Button>) : ("Seleziona")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      clients.map((client, index) => {
                        client.index = index
                        let link = (type == 'evolution' ? '/evolution/' : '/statistiche-competitor/') + client.id
                        return (
                          <tr key={client.id} onClick={() => { this.props.user.settoriale == 1 ? this.handleChangeSelectedClients(client) : null }}>
                            <td><Link to={link} id={`btn-${client.index}`}>{client.label}</Link> {client.incid_az_su_cliente_sim != null ? <p className="client-legend dot-qclient" id={`dot-${client.index}`}></p> : ""
                            }</td>
                            {client.incid_az_su_cliente_sim != null ?
                              <Tooltip placement="bottom"
                                isOpen={this.isTooltipOpen(`dot-${client.index}`)}
                                target={`dot-${client.index}`}
                                toggle={() => this.toggleTooltip(`dot-${client.index}`)}>Inc. simulata: {client.incid_az_su_cliente_sim}</Tooltip> : ""
                            }
                            <Tooltip placement="bottom"
                              isOpen={this.isTooltipOpen(`btn-${client.index}`)}
                              target={`btn-${client.index}`}
                              toggle={() => this.toggleTooltip(`btn-${client.index}`)}> {client.name}</Tooltip>

                            {this.props.user.settoriale == 0 ? (<td onClick={() => this.selectAteco(client.ateco_2007)}>{client.ateco_2007}</td>) : null}
                            <td>{client.and_cliente_ac_perc}</td>
                            <td>{client.position}</td>
                            <td className="text-center">
                              <FormGroup check>
                                <Label check>
                                  <Input type="checkbox" name={client.id}
                                    checked={client.checked}
                                    onChange={() => { this.handleChangeSelectedClients(client) }} />
                                  <span className="form-check-sign">
                                    <span className="check" />
                                  </span>
                                </Label>
                              </FormGroup>
                            </td>
                          </tr>
                        )
                      })
                    }
                  </tbody>
                </Table>
                <div className="clearfix">
                  {nextBtn}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>)
      }

    }
  }
}

ClientsList.propTypes = {
  btnTitle: PropTypes.string.isRequired,
  onDataDownloaded: PropTypes.func
};

export default ClientsList;
